import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { StringCustomFieldConfig, SharedModule, FormInputComponent } from '@vendure/admin-ui/core';

@Component({
    template: `
        <textarea class="disabled-text-form" [formControl]="formControl" rows="10" readonly></textarea>
    `,
    styleUrls: ['./disabled-text-form.component.scss'],
    standalone: true,
    imports: [SharedModule],
})
export class DisabledTextFormComponent implements FormInputComponent<StringCustomFieldConfig> {
    readonly: boolean;
    config: StringCustomFieldConfig;
    formControl: FormControl;
}
